import { getHttpClientAsLastParam } from 'ContentData/helpers/apiHelpers';
/**
 * GET designmanager/v1/theme/by-path/{path}/settings
 */
export function fetchThemeSettings(path, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get(`designmanager/v1/themes/by-path/${encodeURIComponent(path)}/settings`);
}